import React from "react";
import { FaProjectDiagram, FaUsers, FaTruck } from "react-icons/fa";
import AnimatedCountUp from "../components/AnimatedCountUp";
import "./StatisticsSection.css";

const ICON_MAP = {
  projects: FaProjectDiagram,
  users: FaUsers,
  truck: FaTruck,
};

const StatisticsSection = ({ data }) => {
  const subtitle = data?.subtitle || "Our Achievements";
  const title = data?.title || "Trusted by Businesses Across UAE";
  const items = data?.items?.length
    ? data.items
    : [
        {
          value: "1000",
          suffix: "+",
          label: "Projects Completed",
          iconKey: "projects",
          animate: true,
        },
        {
          value: "500",
          suffix: "+",
          label: "Corporate Clients",
          iconKey: "users",
          animate: true,
        },
        {
          value: "UAE",
          suffix: "",
          label: "Wide Delivery",
          iconKey: "truck",
          animate: false,
        },
      ];

  return (
    <section className="stats-section">
      <div className="stats-header">
        <span>{subtitle}</span>
        <h2>{title}</h2>
      </div>

      <div className="stats-container">
        {items.map((item, index) => {
          const Icon = ICON_MAP[item.iconKey] || FaProjectDiagram;
          const numeric = Number(String(item.value || "").replace(/,/g, ""));
          const canAnimate = item.animate !== false && !Number.isNaN(numeric);

          return (
            <div className="stat-card" key={item._id || index}>
              <div className="stat-icon">
                <Icon />
              </div>
              <h3>
                {canAnimate ? (
                  <AnimatedCountUp
                    end={numeric}
                    duration={4}
                    separator=","
                    suffix={item.suffix || ""}
                  />
                ) : (
                  `${item.value || ""}${item.suffix || ""}`
                )}
              </h3>
              <p>{item.label}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default StatisticsSection;
